import ActionsForm from '@/shared/mixins/actionsForm'
import FilterSeveralContributor from './components/FilterSeveralContributor/FilterSeveralContributor.vue'
import tablecollaborator from './components/tablecollaborator/tablecollaborator.vue'
import tablepaidlots from './components/tablelotspaid/tablepaidlots.vue'
import Filtermiscellaneouslots from './components/Filtermiscellaneouslots/Filtermiscellaneouslots.vue'

// Tela de CONSULTA de Despesas Diversas (perfil ACC_ZPAG_DIVERSOS_CONSULTA).
// Read-only: expoe apenas as abas Colaboradores e Lotes Pagos (isConsulta=true zera as acoes de
// escrita dentro de cada componente). O escopo por empresa e travado no backend (ContaEmpresa).
export default {
  name: 'miscellaneousreimbursementconsulta',
  components: {
    FilterSeveralContributor,
    tablecollaborator,
    tablepaidlots,
    Filtermiscellaneouslots
  },
  mixins: [ActionsForm],
  data () {
    return {
      tabIndex: 0
    }
  },

  // ZC-46: o botao Retornar da tela de lotes do colaborador usa `$router.back()`, entao volta para
  // ESTA tela -- mas a aba resetava para 0 e o Rodrigo caia em "Prestacao de Conta" em vez de
  // "Colaboradores", que e de onde ele veio.
  //
  // Por que NAO e um `$router.push('/despesa/diversos?aba=2')` no botao: as duas telas de Diversos
  // compartilham a MESMA tela de lotes, e o indice da aba Colaboradores e diferente em cada uma
  // (2 aqui, 0 na `miscellaneousreimbursementconsulta`). Alem disso a rota `/despesa/diversos`
  // exige role de escrita, que o usuario de consulta nao tem -- push fixo mandaria ele para uma
  // rota que o guard barra. Guardar o indice por rota resolve as duas com o mesmo codigo.
  //
  // `sessionStorage` e nao `localStorage`: a aba certa e a da navegacao corrente, nao uma
  // preferencia que sobrevive semanas.
  created () {
    try {
      var salvo = sessionStorage.getItem('abaDiversos:' + this.$route.path)
      if (salvo !== null && !isNaN(parseInt(salvo, 10))) this.tabIndex = parseInt(salvo, 10)
    } catch (e) { /* navegador sem storage: segue no default */ }
  },
  watch: {
    tabIndex (valor) {
      try {
        sessionStorage.setItem('abaDiversos:' + this.$route.path, String(valor))
      } catch (e) { /* idem */ }
    }
  },
  methods: {
    search (data) {
      if (this.tabIndex === 0) {
        this.$refs.tablecollaborator.formSearch = data
        this.$refs.tablecollaborator.onLoad(this.$refs.tablecollaborator.formSearch)
      }
      if (this.tabIndex === 1) {
        this.$refs.diversosLotes.dataSearch = data
        this.$refs.diversosLotes.Onload(this.$refs.diversosLotes.dataSearch)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/miscellaneousreimbursement/miscellaneousreimbursementconsulta.js